import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";
import { useI18n } from "../contexts/I18nContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { t } = useI18n();

  useEffect(() => {
    const prev = document.title;
    document.title = t("signing_in_title");
    return () => {
      document.title = prev;
    };
  }, [t]);

  useEffect(() => {
    if (!loading) {
      if (user) {
        navigate("/app", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-[#02371b] text-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-white/20 border-t-[#41a42b] rounded-full animate-spin mx-auto mb-4" />
        <p className="text-xs tracking-[0.25em] uppercase text-white/60">{t("signing_in_desc")}</p>
      </div>
    </div>
  );
}
